import $ from 'jquery'

const $doc = $(document)
function menuDropdownA11y() {
  /*
  Adapted from: An accessible menu for WordPress
  https://github.com/argenteum/accessible-nav-wp
  Licensed GPL v.2 (http://www.gnu.org/licenses/gpl-2.0.html)
  This work derived from:
  https://github.com/WordPress/twentysixteen (GPL v.2)
  https://github.com/wpaccessibility/a11ythemepatterns/tree/master/menu-keyboard-arrow-nav (GPL v.2)
  */

  let menuContainer = $('.js-header');
  let siteHeaderMenu = menuContainer.find('.js-mobile-nav');

  // If you are using WordPress, and do not need to localise your script, or if you are not using WordPress, then uncomment the next line

  let screenReaderText = {"expand":"Expand child menu","collapse":"Collapse child menu"};

  let dropdownToggle = $('<button />', { 'class': 'dropdown-toggle', 'aria-expanded': false })
    .append($('<span />', { 'class': 'u-sr-only', text: screenReaderText.expand }));


  // Adds the dropdown toggle button
  $('.js-mobile-nav > ul > .menu-item-has-children > a').after(dropdownToggle);

  // Adds aria attribute
  $('.js-mobile-nav > ul > .menu-item-has-children').attr('aria-haspopup', 'true');

  // Toggles the sub-menu when dropdown toggle button clicked
  siteHeaderMenu.find('.dropdown-toggle').click(function (e) {

    let screenReaderSpan = $(this).find('.u-sr-only');

    e.preventDefault();
    $(this).toggleClass('toggled-on');
    $(this).nextAll('.sub-menu').toggleClass('toggled-on').slideToggle();

    // jscs:disable
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false'
      ? 'true' : 'false');
    // jscs:enable
    screenReaderSpan.text(screenReaderSpan.text() ===
      screenReaderText.expand ? screenReaderText.collapse :
      screenReaderText.expand);
  });

  // Adds a class to sub-menus for styling
  $('.js-mobile-nav .sub-menu .menu-item-has-children').parent('.sub-menu').addClass('has-sub-menu');


  // Keyboard navigation
  $('.js-mobile-nav .menu-item a, button.dropdown-toggle').on('keydown', function (e) {

    if ([37, 38, 39, 40].indexOf(e.keyCode) == -1) {
      return;
    }

    switch (e.keyCode) {

      case 37: 				// left key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('dropdown-toggle')) {
          $(this).prev('a').focus();
        }
        else {

          if ($(this).parent().prev().children('button.dropdown-toggle').length) {
            $(this).parent().prev().children('button.dropdown-toggle').focus();
          }
          else {
            $(this).parent().prev().children('a').focus();
          }
        }

        if ($(this).is('ul ul ul.sub-menu.toggled-on li:first-child a')) {
          $(this).parents('ul.sub-menu.toggled-on li').children('button.dropdown-toggle').focus();
        }

        break;

      case 39: 				// right key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next('button.dropdown-toggle').length) {
          $(this).next('button.dropdown-toggle').focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if ($(this).is('ul.sub-menu .dropdown-toggle.toggled-on')) {
          $(this).parent().find('ul.sub-menu li:first-child a').focus();
        }

        break;


      case 40: 				// down key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next().length) {
          $(this).next().find('li:first-child a').first().focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu a')) && ($(this).next('button.dropdown-toggle').length)) {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().next().children('.dropdown-toggle').length)) {
          $(this).parent().next().children('.dropdown-toggle').focus();
        }

        break;


      case 38: 				// up key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).parent().prev().length) {
          $(this).parent().prev().children('a').focus();
        }
        else {
          $(this).parents('ul').first().prev('.dropdown-toggle.toggled-on').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().prev().children('.dropdown-toggle').length)) {
          $(this).parent().prev().children('.dropdown-toggle').focus();
        }

        break;

    }
  });
}

function fixWpconsentA11y() {
  window.addEventListener('load', function() {
    var root = document.getElementById('wpconsent-root');
    if (!root || !root.shadowRoot) return;
    var msg = root.shadowRoot.querySelector('.wpconsent-banner-message');
    if (msg) {
      msg.setAttribute('role', 'region');
      msg.setAttribute('aria-label', 'Cookie consent message');
    }
  });
} 


function unwrapUnderlineTags() {
  document.querySelectorAll('a u').forEach(function(u) {
    while (u.firstChild) {
      u.parentNode.insertBefore(u.firstChild, u);
    }
    u.parentNode.removeChild(u);
  });
}

// Idempotent attribute writes: setAttribute/removeAttribute queue a MutationRecord
// even when the value does not change, which can feed an observer's own callback
// back into itself. Only touch the DOM when something actually differs.
function setAttr(el, name, value) {
  if (el.getAttribute(name) !== value) el.setAttribute(name, value)
}
function removeAttr(el, name) {
  if (el.hasAttribute(name)) el.removeAttribute(name)
}

// Run `sync` on load, then on relevant mutations — but coalesce bursts into one
// pass per frame and disconnect while writing, so a sync's own DOM writes (and the
// churn from libraries like slick) can never retrigger the observer. Without this,
// slick's continuous slide-attribute rewrites at mobile widths drove these
// document-wide observers into an unbounded mutation->callback->mutation loop that
// froze the main thread below the `lg` (960px) breakpoint.
function safeWatch(sync, options) {
  sync()
  if (!window.MutationObserver) return
  let scheduled = false
  const observer = new MutationObserver(() => {
    if (scheduled) return
    scheduled = true
    window.requestAnimationFrame(() => {
      scheduled = false
      observer.disconnect()
      try {
        sync()
      } finally {
        observer.observe(document.documentElement, options)
      }
    })
  })
  observer.observe(document.documentElement, options)
}

const FOCUSABLE_IN_HIDDEN = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'

// Focusables can live inside shadow roots, which light-DOM querySelector cannot
// see. The WPConsent consent banner renders into #wpconsent-container's shadow
// root, so an aria-hidden wrapper around it contains no light-DOM focusables at
// all — the shallow check below misses it, the wrapper stays focusable, and
// AAArdvark/axe re-flags the banner buttons after every rescan. Walk into shadow
// roots (bounded depth) so shadow-DOM widgets get the same inert treatment as
// plain light-DOM content.
function containsFocusableDeep(node, depth = 2) {
  if (node.querySelector(FOCUSABLE_IN_HIDDEN)) return true
  if (depth <= 0) return false
  const roots = []
  if (node.shadowRoot) roots.push(node.shadowRoot)
  for (const el of node.querySelectorAll('*')) {
    if (el.shadowRoot) roots.push(el.shadowRoot)
  }
  return roots.some((root) => containsFocusableDeep(root, depth - 1))
}

function syncInertForHiddenTrees() {
  document.querySelectorAll('[aria-hidden="true"]').forEach((el) => {
    if (el === document.body || el === document.documentElement) return
    if (el.classList.contains('js-mobile-nav')) return
    if (!containsFocusableDeep(el)) return
    setAttr(el, 'inert', '')
    setAttr(el, 'data-a11y-inert', '')
  })
  document.querySelectorAll('[data-a11y-inert]').forEach((el) => {
    if (el.getAttribute('aria-hidden') === 'true') return
    removeAttr(el, 'inert')
    removeAttr(el, 'data-a11y-inert')
  })
}

function watchHiddenTrees() {
  safeWatch(syncInertForHiddenTrees, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  })
}

// The two WPConsent root elements exist solely to host the consent banner's
// shadow tree. If some other script drops aria-hidden="true" on them while the
// banner is on screen, the visible dialog vanishes from assistive technology
// and AAArdvark/axe report its buttons as "focusable inside aria-hidden". The
// banner manages its own visibility (display + .wpconsent-banner-visible), so
// while it is showing the foreign attribute is always wrong — remove it. While
// it is hidden the elements are display:none and need no correction.
const WPCONSENT_CHAIN_SELECTORS = ['#wpconsent-root', '#wpconsent-container']

function wpconsentBannerVisible() {
  const container = document.getElementById('wpconsent-container')
  const holder = container && container.shadowRoot &&
    container.shadowRoot.querySelector('#wpconsent-banner-holder')
  return !!(holder && holder.classList.contains('wpconsent-banner-visible'))
}

function guardWpconsentChain() {
  if (!wpconsentBannerVisible()) return
  WPCONSENT_CHAIN_SELECTORS.forEach((selector) => {
    const el = document.querySelector(selector)
    if (el && el.getAttribute('aria-hidden') === 'true') removeAttr(el, 'aria-hidden')
  })
}

// The banner reveal happens inside the shadow root after an async CSS load, so
// hook the plugin's own lifecycle (afterShowBanner) in addition to watching the
// document for aria-hidden writes. window.WPConsent appears later than this
// bundle, so poll briefly for it.
let wpconsentHooksRegistered = false

function registerWpconsentHooks(attempt = 0) {
  if (!wpconsentHooksRegistered) {
    wpconsentHooksRegistered = true
    window.addEventListener('wpconsent_banner_initialized', guardWpconsentChain)
    window.addEventListener('wpconsent_consent_saved', guardWpconsentChain)
  }
  if (window.WPConsent && typeof window.WPConsent.addHook === 'function') {
    window.WPConsent.addHook('afterShowBanner', guardWpconsentChain)
    window.WPConsent.addHook('afterHideBanner', guardWpconsentChain)
    guardWpconsentChain()
    return
  }
  if (attempt < 20) {
    window.setTimeout(() => registerWpconsentHooks(attempt + 1), 250)
  }
}

function watchWpconsentChain() {
  guardWpconsentChain()
  registerWpconsentHooks()
  safeWatch(guardWpconsentChain, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  })
}

/**
 * AAArdvark/AccessiBe flags visible slider-arrow SVGs as non-decorative
 * even when the parent button already has aria-label. Give the SVG its own
 * name (title + aria-label) so the graphic has an accessible name.
 */
function nameSliderArrowSvgs() {
  document.querySelectorAll('.slick-arrow svg, .slick-next svg, .slick-prev svg').forEach((svg) => {
    const btn = svg.closest('button, a, [role="button"]')
    const isPrev = !!(svg.closest('.slick-prev') || (btn && btn.classList.contains('slick-prev')))
    const label = (btn && (btn.getAttribute('aria-label') || btn.textContent.trim())) || (isPrev ? 'Previous' : 'Next')
    setAttr(svg, 'role', 'img')
    setAttr(svg, 'aria-label', label)
    setAttr(svg, 'focusable', 'false')
    removeAttr(svg, 'aria-hidden')
    let title = svg.querySelector('title')
    if (!title) {
      title = document.createElementNS('http://www.w3.org/2000/svg', 'title')
      svg.insertBefore(title, svg.firstChild)
    }
    if (title.textContent !== label) title.textContent = label
  })
}

function watchSliderArrowSvgs() {
  safeWatch(nameSliderArrowSvgs, {
    subtree: true,
    childList: true
  })
}

/**
 * Slick dots mode sets role="tabpanel" + aria-describedby, but describedby is
 * not an accessible name (WCAG 4.1.2). Name every tabpanel from its heading,
 * the matching dot, or "Slide N of M".
 */
function nameSlickTabpanels() {
  document.querySelectorAll('.slick-slide[role="tabpanel"]').forEach((slide) => {
    if (slide.getAttribute('aria-label') || slide.getAttribute('aria-labelledby')) return

    const heading = slide.querySelector('.hero__title, h1, h2, h3, h4')
    const headingText = heading && heading.textContent.replace(/\s+/g, ' ').trim()
    if (headingText) {
      setAttr(slide, 'aria-label', headingText)
      return
    }

    const describedBy = slide.getAttribute('aria-describedby')
    if (describedBy && document.getElementById(describedBy)) {
      setAttr(slide, 'aria-labelledby', describedBy)
      return
    }

    const idx = parseInt(slide.getAttribute('data-slick-index'), 10)
    const slider = slide.closest('.slick-slider')
    const count = slider ? slider.querySelectorAll('.slick-slide:not(.slick-cloned)[data-slick-index]').length : 0
    const n = Number.isNaN(idx) || idx < 0 ? 1 : idx + 1
    setAttr(slide, 'aria-label', count ? `Slide ${n} of ${count}` : `Slide ${n}`)
  })
}

function watchSlickTabpanels() {
  safeWatch(nameSlickTabpanels, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['role']
  })
}

export default function initA11yFunctions(){
  menuDropdownA11y();
  fixWpconsentA11y();
  unwrapUnderlineTags();
  watchHiddenTrees();
  watchWpconsentChain();
  watchSliderArrowSvgs();
  watchSlickTabpanels();
}
